module.exports = __webpack_public_path__ + "user-placeholder.fd4b3910137a5cbcbd834121d24f1877.hashedasset.svg";